import mapValues from 'lodash/mapValues';
import map from 'lodash/map';
import kebabCase from 'lodash/kebabCase';

/** Сначала значение для светлой темы (light), затем для темной (dark) */
type ColorsType = [string, string];
/** Префикс добавляемый генерируемой css переменной */
type PrefixType = 'ut' | 'text' | 'graph' | 'scroll';

/** Эта функция помогает прокинуть объекту типы для значений минуя сами ключи" */
export const makeColors = <T extends Record<string, ColorsType>>(colors: T) => colors;

export const getColors = <T extends Record<string, ColorsType>>(colors: T, prefix: PrefixType) =>
  mapValues(
    colors,
    (color: ColorsType, key) => `var(--color-${prefix}-${kebabCase(key)}, ${color[0]})`
  );

export const createColorsCssVariables = (
  colors: { [key: string]: ColorsType },
  prefix: PrefixType,
  theme: 'light' | 'dark'
) =>
  map(
    colors,
    (color, key) => `--color-${prefix}-${kebabCase(key)}: ${color[theme === 'light' ? 0 : 1]}`
  ).join(';');
